<script>
    import Loading from "./common/loading.vue";
    import DialogBase from "./dialog/components/dialog-base.vue";
    import DialogHeader from "./dialog/components/dialog-header.vue";
    import DialogBody from "./dialog/components/dialog-body.vue";

    export default {
        name: "changelog-dialog",
        components: {DialogBody, DialogHeader, DialogBase, Loading},
        data() {
            return {
                showDialog: false,
                loading: false,
                content: '',
            }
        },
        computed: {
            translations() {
                return {
                    close: Lang.langGet("Close"),
                    title: Lang.langGet("Changelog"),
                }
            }
        },
        methods: {
            show() {
                this.loadChangelog();
                this.showDialog = true;
            },
            hide() { this.showDialog = false; },
            handleClose() {
                this.hide();
            },
            async loadChangelog(){
                if (!this.loading) {
                    this.loading = true;
                    const response = await axios.get('/system/changelog');
                    this.content = response.data.changelog.replace(/<\/h2>/g, '</h2><hr/>');
                    this.loading = false;
                }
            }
        },
        async mounted() {
            EaseEventBus.listen('showChangelog', () => {
                this.show();
            });
        }
    }
</script>

<template>
    <dialog-base
        :maxWidth="960"
        @close="handleClose"
        :showDialog="showDialog"
    >
        <dialog-header
            @close="handleClose"
            :title="translations.title"
        />
        <loading :loading="loading"/>
        <dialog-body :minHeight="400">
            <div class="changelog-dialog-content" v-html="content"/>
        </dialog-body>
    </dialog-base>
</template>

<style>
    .changelog-dialog-content {
        height: 80vh;
        padding: 16px;
        overflow-y: scroll;
    }

    .changelog-dialog-content h2 {
        margin-top: 8px !important;
        margin-bottom: 0 !important;
        text-align: center !important;
    }

    .changelog-dialog-content hr {
        margin-top: 0 !important;
    }

    .changelog-dialog-content ul {
        margin-left: 32px !important;
    }
</style>
